import { SxProps } from "@mui/material";

export const sxOption: SxProps = {
    fontFamily: "UnimedSans-Bold",
    fontSize: "16px",
    lineHeight: "24px",
};